import { Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";

const products = [
  {
    name: "Green Tea",
    price: 900,
    size: "80g",
    image: "https://images.pexels.com/photos/8474089/pexels-photo-8474089.jpeg",
  },
  {
    name: "Genmaicha",
    price: 300,
    size: "50g",
    image: "https://images.pexels.com/photos/7144915/pexels-photo-7144915.jpeg",
  },
  {
    name: "Red Tea",
    price: 150,
    size: "10g",
    image: "https://images.pexels.com/photos/7113851/pexels-photo-7113851.jpeg",
  },
  {
    name: "Hojicha",
    price: 1200,
    size: "100g",
    image: "https://images.pexels.com/photos/5946651/pexels-photo-5946651.jpeg",
  },
];

export default function MenuPage() {
  return (
    <div className="min-h-screen mx-auto max-w-6xl px-6 py-24">
      <div className="mb-10">
        <h1 className="text-3xl md:text-4xl font-semibold">Menu</h1>
        <p className="mt-2 text-muted-foreground">
          Premium selections available in-store and for local delivery.
        </p>
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {products.map((p) => (
          <Card key={p.name} className="overflow-hidden border-border">
            <CardHeader className="p-0">
              <img src={p.image} alt={p.name} className="h-52 w-full object-cover" />
            </CardHeader>
            <CardContent className="p-5">
              <div className="flex items-start justify-between gap-3">
                <CardTitle className="text-lg">{p.name}</CardTitle>
                <div className="text-right">
                  <div className="font-semibold text-primary">{p.price.toLocaleString()} THB</div>
                  <div className="text-xs text-muted-foreground">{p.size}</div>
                </div>
              </div>
              <Button
                className="mt-5 w-full bg-primary text-primary-foreground hover:opacity-95"
                variant="default"
              >
                Add to cart
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
